import { useState, useEffect } from 'react';
import get from 'lodash/get';
/**
 * This is a custom hook to determine if the text has overflown the width of the container.
 * Useful only with CSS `text-overflow: ellipsis;`.
 * TODO: This is a useful utility, we can expose this through Path.
 */

function useTextOverflow(elementRef, selector) {
  var _useState = useState(false),
      overflow = _useState[0],
      setOverflow = _useState[1];

  useEffect(function () {
    var element = selector ? get(elementRef, 'current') && elementRef.current.querySelector(selector) : elementRef.current;

    if (element && element.offsetWidth < element.scrollWidth) {
      setOverflow(true);
    }
  }, [elementRef, selector]);
  return [overflow, setOverflow];
}

export default useTextOverflow;